export default "__VITE_ASSET__Damj1O4f__"